import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const appraisalEvaluationsStyle: StyleRulesCallback = () => ({
  root: {},
});

export default appraisalEvaluationsStyle;
